import React from 'react';
import { Calendar } from 'lucide-react';

const CalendarLoader = () => {
  return (
    <div className="bg-white rounded-lg shadow w-full flex items-center justify-center" style={{ height: "calc(100vh - 200px)" }}>
      <div className="relative flex items-center justify-center">
        {/* Very dense pulsating rings with varied timing */}
        <div className="absolute w-14 h-14 rounded-full border border-blue-200 opacity-80 animate-ping" style={{ animationDuration: '1.1s' }}></div>
        <div className="absolute w-16 h-16 rounded-full border border-blue-300 opacity-70 animate-ping" style={{ animationDuration: '1.4s' }}></div>
        <div className="absolute w-18 h-18 rounded-full border border-blue-100 opacity-60 animate-ping" style={{ animationDuration: '1.7s' }}></div>
        <div className="absolute w-20 h-20 rounded-full border border-blue-200 opacity-50 animate-ping" style={{ animationDuration: '2.0s' }}></div>
        <div className="absolute w-22 h-22 rounded-full border border-blue-100 opacity-40 animate-ping" style={{ animationDuration: '2.3s' }}></div>
        <div className="absolute w-24 h-24 rounded-full border border-blue-200 opacity-30 animate-ping" style={{ animationDuration: '2.6s' }}></div>
        <div className="absolute w-28 h-28 rounded-full border border-blue-100 opacity-20 animate-ping" style={{ animationDuration: '2.9s' }}></div>
        
        {/* Background circle for icon */}
        <div className="relative z-10 w-12 h-12 bg-white rounded-full shadow-sm flex items-center justify-center">
          <Calendar size={24} className="text-blue-500" />
        </div>
      </div>
    </div>
  );
};

export default CalendarLoader;